import type { ComponentProps } from "react";
import { cn } from "@/shared/utils/cn";

interface IconBadgeProps extends ComponentProps<"span"> {
  size?: "sm" | "md" | "lg";
  tone?: "muted" | "primary" | "ai" | "cream";
}

export function IconBadge({
  size = "md",
  tone = "muted",
  className,
  ...props
}: IconBadgeProps) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-xl",
        size === "sm" && "size-8 [&>svg]:size-4",
        size === "md" && "size-10 [&>svg]:size-5",
        size === "lg" && "size-12 [&>svg]:size-6",
        tone === "muted" && "bg-muted text-muted-foreground",
        tone === "primary" && "bg-secondary text-primary",
        tone === "ai" && "bg-lilac text-lilac-foreground",
        tone === "cream" && "bg-cream text-foreground",
        className,
      )}
      {...props}
    />
  );
}
